var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name != 'Dashboard')?_c('button',{ref:"component_btn_back",staticClass:"btn-outline-dark btn-rounded btn",on:{"click":function($event){return _vm.backPage()}}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h6',[_c('i',{staticClass:"fa fa-arrow-circle-left",staticStyle:{"vertical-align":"sub"}}),_vm._v(" Regresar ")])
}]

export { render, staticRenderFns }